/*
 * Copyright (c) 2021. American Express Company
 */

import { CryptoModel } from 'src/types/crypto.model';
import BWDataService from './bw-data.service';

export default class CryptoService extends BWDataService {
    // Bug in TS! Won't support public static override async
    // @ts-ignore
    public static async get(): Promise<CryptoModel[]> {
        return await super.get('/crypto');
    }
}
